// "Prospectos Landing" dentro del módulo de asesoras. La pantalla interna es
// la misma de admin (pages/administrador/filtro/prospects) y no se modifica.
import Prospectos from 'pages/administrador/filtro/prospects';
import { PageHeader, SectionCard } from './components/ui';

export default function ProspectosLandingAdviser() {
  return (
    <>
      <PageHeader title="Prospectos Landing" subtitle="Búsqueda en todos los prospectos de Klazia." />
      <SectionCard padding={4}>
        <Prospectos allowTransfer={false} />
      </SectionCard>
    </>
  );
}
